import { CashierMethod, CashierPaymentType } from './cashier.models';

/**
 * Angka dan daftar pilihan layar kasir, dikumpulkan di satu tempat (sebelumnya tersebar di
 * template dan komponen Cashpay). Nilainya sama dengan Cashpay lama.
 */

/** Biaya admin siswa OTS bila student.admin_fee kosong. */
export const OTS_ADMIN_FEE_FALLBACK = 60000;

/** Cicilan #2 paket EM/EMP 6 bulan: DP 20% harga paket + nominal tetap cicilan kedua. */
export const EMP_DP_RATIO = 0.2;
export const EMP_TERM2_AMOUNT = 3426000;

/** Durasi paket (hari) minimal yang boleh memakai cicilan EM/EMP. */
export const EMP_MIN_DURATION = 120;

export const OTS_STATUSES = ['OTS', 'OTSFBIO'];
export const UNPAID_STATUSES = ['REGISTERED', ...OTS_STATUSES];

export const PAYMENT_TYPE_LABELS: Record<CashierPaymentType, string> = {
  FP: 'Pelunasan',
  DPFP: 'DP + Pelunasan',
  DPTP2EMP: 'DP + Cicilan #2 EM/EMP 6M',
  TP2EMP: 'Cicilan #2 Paket EM/EMP',
};

export const METHOD_OPTIONS: { value: CashierMethod; label: string }[] = [
  { value: 'CASH', label: 'Cash' },
  { value: 'NONCASH', label: 'EDC' },
  { value: 'TRANSFER', label: 'Transfer' },
  { value: 'CASH-TF', label: 'Cash dan Transfer' },
  { value: 'CASH-QRIS', label: 'Cash dan QRIS' },
  { value: 'QRIS', label: 'QRIS' },
];

export const BANKS = ['BCA', 'BNI', 'BSI', 'BRI', 'MANDIRI'];
export const DEFAULT_NONCASH_BANK = 'MANDIRI';

export const PICKUP_LABELS: Record<string, string> = {
  n: 'Tidak dijemput',
  motor: 'Motor',
  car: 'Mobil',
};

export const PICKUP_LOCATION_LABELS: Record<string, string> = {
  tk: 'Terminal Kediri',
  sk: 'Stasiun Kediri',
  sj: 'Stasiun Jombang',
  bj: 'Bandara Juanda',
};

export const MONTH_NAMES = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember',
];
